import apiClient from "../apiClient";

const resource = "Health";

export default {
    getHealth: params => apiClient.get(`${resource}/Health?${params}`),

};
